module.exports = __webpack_public_path__ + "static/media/IMG-12.c6e62115.jpg";